import { MainBorrowerProfilingAction } from "./actions/types";
import { MainBorrowerProfilingState } from "./types";


export const initialState: MainBorrowerProfilingState = {
  borrowerProjectId: null,
  borrowerProjectInfos: null,
  isLoading: false,
  error: null
}

export const mainBorrowerProfilingReducer = (
  state: MainBorrowerProfilingState,
  action: MainBorrowerProfilingAction): MainBorrowerProfilingState => {
  switch (action.type) {
    case 'SET_BORROWER_PROJECT_ID':
      return {
        ...state,
        borrowerProjectId: action.payload,
      }
    case 'SET_BORROWER_PROJECT_INFOS':
      return {
        ...state,
        borrowerProjectInfos: action.payload,
      }
    case 'SET_LOADING':
      return { ...state, isLoading: action.payload }
    case 'SET_ERROR':
      return { ...state, error: action.payload, isLoading: false }
    case 'RESET':
      return initialState
    default:
      return state
  }
}
